if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.product-tabs__tab'));
      this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));
      if (this.tabs.length === 0) return;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (e) => this.onKeydown(e, index));
      });
      const initial = parseInt(this.dataset.defaultIndex || '0', 10);
      this.activate(Number.isNaN(initial) ? 0 : initial);
      this.setAttribute('data-ready', '');
    }
    activate(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });
      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
        panel.hidden = i !== index;
      });
    }
    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      switch (event.key) {
        case 'ArrowRight': next = index === last ? 0 : index + 1; break;
        case 'ArrowLeft':  next = index === 0 ? last : index - 1; break;
        case 'Home': next = 0; break;
        case 'End':  next = last; break;
        default: return;
      }
      event.preventDefault();
      this.activate(next);
      this.tabs[next].focus();
    }
  });
}

// 星評価バッジ（タイトル直下）クリックで Reviews タブを開いてスクロール
if (!window.__productTabsBadgeBound) {
  window.__productTabsBadgeBound = true;
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-open-reviews');
    if (!trigger) return;
    const tabsEl = document.querySelector('product-tabs');
    if (!tabsEl || !tabsEl.tabs) return;
    const idx = tabsEl.tabs.findIndex((t) => {
      const c = t.getAttribute('aria-controls') || '';
      return c.indexOf('ProductPanel-reviews') === 0;
    });
    if (idx >= 0) {
      e.preventDefault();
      tabsEl.activate(idx);
      tabsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}